// TODO: replace with SX

export const getStyles = (theme, { isActive, maxAvatars } = {}) => ({
  wrapper: {
    margin: '1px 10px 0 0',

    '& .MuiAvatar-root': {
      ...Array.from({ length: maxAvatars }, (_, i) => i + 1).reduce((acc, cur, index) => {
        acc[`&:nth-of-type(${cur})`] = {
          marginRight: '-10px',
          boxSizing: 'border-box !important',
          height: '33px',
          width: '33px',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.paper,
          borderWidth: `${isActive ? 2 : 1}px !important`,
          borderStyle: 'solid',
          borderColor: `${isActive ? '#30A746' : '#E7E6E6'} !important`,
          fontSize: '1.4rem',
          fontWeight: 500,
          fontFamily: 'Roboto, sans-serif !important',
          cursor: 'pointer',
          zIndex: `${index + 1} !important`,
        };

        return acc;
      }, {}),
    },

    '& .MuiAvatarGroup-avatar': {
      cursor: 'unset !important',
    },
  },
});

export const tooltipStyles = {
  width: '295px',
  padding: '12px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.m,
};
